import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import classNames from 'classnames';
import { Link, withRouter } from 'react-router-dom';
import normalizeInternalLink from 'commons/normalizeInternalLink';
import IconArrowRightSimple from 'components/icons/iconArrowRightSimple';
import CtaLink from 'components/essentials/Cta/CtaLink';
import ShopPageListItem from './ShopPageListItem';
const ShopPageList = t0 => {
  const $ = _c(20);
  const {
    inspirationPath,
    name,
    path,
    subcategories,
    variant
  } = t0;
  const t1 = variant === "LivingRoom";
  let t2;
  if ($[0] !== t1) {
    t2 = classNames("text-xl font-bold text-gary block pb-4 pt-6 px-6 hover:no-underline", {
      "md:max-[1023px]:px-0": t1
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== path) {
    t3 = normalizeInternalLink(path);
    $[2] = path;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== name) {
    t4 = <span>{name}</span>;
    $[4] = name;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className={classNames("w-8 h-8 bg-gray-light8 inline-flex items-center justify-center ml-2.5 rounded-[32px] relative -top-1 transition-all duration-[0.25s]", "[&_svg]:h-3 [&_svg]:left-px [&_svg]:relative [&_svg]:transition-all [&_svg]:duration-[0.25s]", "[*:hover>&]:bg-brand [*:hover>&]:[&_svg_path]:stroke-white", "group-[a:hover+&]/ShopPageCategoryPanel__content:bg-brand group-[a:hover+&]/ShopPageCategoryPanel__content:[&_svg_path]:stroke-white")}><IconArrowRightSimple /></span>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t6 = <Link className={t2} to={t3}>{t4}{t5}</Link>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== subcategories) {
    t7 = !!subcategories.length && <div className="mt-4 md:mx-6 text-base font-bold list-none">{subcategories.map(_temp)}</div>;
    $[11] = subcategories;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== inspirationPath || $[14] !== name) {
    t8 = inspirationPath && <div className="text-sm font-bold text-brand block mt-4 px-6 pb-6 [&_svg]:h-2 [&_svg_path]:fill-brand"><CtaLink to={inspirationPath} color="brand" noLinkPadding={true} className="hover:!text-brand hover:!no-underline">Get {name} Inspiration</CtaLink></div>;
    $[13] = inspirationPath;
    $[14] = name;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t6 || $[17] !== t7 || $[18] !== t8) {
    t9 = <div className="group/ShopPageCategoryPanel__content">{t6}{t7}{t8}</div>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
ShopPageList.propTypes = {
  name: PropTypes.string,
  path: PropTypes.string,
  subcategories: PropTypes.shape({
    map: PropTypes.func,
    subcategoryTitle: PropTypes.string,
    link: PropTypes.string,
    length: PropTypes.number
  }),
  inspirationPath: PropTypes.string,
  variant: PropTypes.oneOf(['LivingRoom'])
};
export default withRouter(ShopPageList);
function _temp(t0) {
  const {
    subcategoryTitle,
    link,
    ...subcategory
  } = t0;
  const product = get(subcategory, "products.products.0", []) || get(subcategory, "products.products.1", []);
  return <ShopPageListItem key={subcategoryTitle} title={subcategoryTitle} product={product} link={link} />;
}